// klm-client-frontend/src/store/api/maintenance.js

import api from './base';

/**
 * Check maintenance status (PUBLIC - no auth required)
 * @returns {Promise} - API response
 */
export const getMaintenanceStatus = async () => {
  const response = await api.get('/maintenance/status');
  return response.data;
};